import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import './MissionVisionSection.css';

import teamImage from '../../assets/team-1.jpg';

const MissionVisionSection = () => {
  return (
    <section className="mission-vision-section py-5">
      <Container>
        <Row className="align-items-center">
          <Col md={5}>
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="position-relative image-box"
            >
              <img src={teamImage} alt="team" className="img-fluid rounded" />

              <div className="diagonal-shapes">
                <div className="green-shape"></div>
                <div className="dark-shape"></div>
              </div>
            </motion.div>
          </Col>

          <Col md={7}>
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
            <h1 className="fw-bold mb-4" style={{ color: '#f5d7e3' }}>
  Organization Mission and Vision Statement for Search Engine Ranking Proposal
</h1>
              <div className="timeline">
                <div className="timeline-item">
                
                 <div>
  <h5 className="fw-semibold text-white">Vision</h5>
  <p className="text-white">Our vision is to lead the event industry with innovation and creativity, delivering unforgettable experiences that inspire and connect people globally.</p>
</div>
                </div>
                <div className="timeline-item">
                
                 <div>
  <h5 className="fw-semibold text-white">Mission</h5>
  <p className="text-white">
    Our mission is to deliver exceptional event experiences by combining strategic planning, creative execution, and a client-focused approach that ensures every event meets its purpose and exceeds expectations.
  </p>
</div>

                </div>
                <div className="timeline-item">
                
                 <div>
  <h5 className="fw-semibold text-white">Goal</h5>
  <p className="text-white">
    Our goal is to become a trusted leader in the event industry by consistently delivering impactful, innovative, and seamless events that drive client success and audience engagement.
  </p>
</div>

                </div>
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MissionVisionSection;
